import { render } from "./print-gaji.vue?vue&type=template&id=4e192fad"
import script from "./print-gaji.vue?vue&type=script&lang=js"
export * from "./print-gaji.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__